"use strict";

exports.__esModule = true;
exports["default"] = exports.setOptimizelyConfig = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSdk = require("@optimizely/react-sdk");

var _getOrSetUUIDCookie = require("./utils/getOrSetUUIDCookie");

var _initializeOptimizely = _interopRequireDefault(require("./initializeOptimizely"));

var _configPlugin = require("@chegg-web-tools/config-plugin");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var $configProvider = {};

var setOptimizelyConfig = function setOptimizelyConfig(configProvider) {
  $configProvider = configProvider;
};

exports.setOptimizelyConfig = setOptimizelyConfig;

var mergeOptConfig = function mergeOptConfig() {
  var staticConfig = (0, _configPlugin.getConfig)('optimizelyConfig');

  var config = _extends({}, staticConfig, $configProvider);

  if (!('sdkKey' in config) && !('datafile' in config)) {
    return null;
  }

  return config;
};

var NextOptimizely = function NextOptimizely(_ref) {
  var children = _ref.children;
  var config = mergeOptConfig();
  var initializedOpt = (0, _initializeOptimizely["default"])(config);

  if (!initializedOpt) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }

  var userObject = {
    /* If config is null we should never arrive here.
     * If this changes in future remove non null assertion.
     */
    id: (0, _getOrSetUUIDCookie.getOrSetUUIDCookie)(config.cookieDomain, config.uuidCookieName),
    attributes: _extends({}, config.attributes)
  };
  return /*#__PURE__*/_react["default"].createElement(_reactSdk.OptimizelyProvider, {
    optimizely: initializedOpt,
    user: userObject,
    isServerSide: false
  }, children);
};

var _default = NextOptimizely;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-optimizely/dist/nextOptimizely.js
// module id = 5733
// module chunks = 11